export default "__VITE_ASSET__Dq2Med7e__"